import { createAction } from "@reduxjs/toolkit";

export interface ApplyCurrentStorePayload {
  storeId: number;
  availableStores: AvailableStoresSliceType;
  location?: Partial<LocationType>;
  resetCheckoutService: boolean;
  // Store name shown by the checkout modal when the service was cleared
  storeChangeNotice?: string;
  // Background correction: skips the change location modal
  silent?: boolean;
}

// Single write point for the active store, dispatched through utils/storeCoverage
export const applyCurrentStore = createAction<ApplyCurrentStorePayload>("storeSync/applyCurrentStore");
